import { useMediaQuery } from "@mantine/hooks";

/**
 * True below Mantine's `sm` breakpoint — the same threshold `AppShell` uses to collapse the
 * navbar, so "mobile" means one thing across the app rather than a per-page guess.
 *
 * The query is byte-identical to the one Mantine generates for `visibleFrom="sm"`
 * (`@media (max-width: em(768 - 0.1))`). Rounding it to 48em would leave a hairline band where
 * a component branching on this hook disagrees with a sibling branching on the CSS utility.
 *
 * `getInitialValueInEffect: false` reads `matchMedia` during the first render instead of after
 * it. The default defers to an effect, which paints the desktop tree once and then swaps; where
 * the two layouts differ structurally (a table becoming a card list) that lands as a visible
 * flash of exactly the layout we are replacing.
 */
export default function useIsMobile() {
  return useMediaQuery("(max-width: 47.99375em)", false, {
    getInitialValueInEffect: false,
  });
}
